import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, DialogModule, InputTextModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { WorkRecordRepository } from './work-record.repository';
import { CompanyModalComponent } from './company-modal/company-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    TranslateModule
  ],
  declarations: [
    CompanyModalComponent
  ],
  providers: [
    WorkRecordRepository
  ],
  entryComponents: [
    CompanyModalComponent
  ]
})
export class WorkRecordModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/work-record.module.ts